import { Behavior, getMediaSource } from "@source-digital/experience-core";
import { toValue } from "@vueuse/core";
import { inject, ref, computed, defineComponent, h, toRefs, unref } from "vue";
import canAutoplay from "can-autoplay";
const INJECTION_KET_BEHAVIOR = Symbol("behavior");
function useExperiencePlayer(args) {
  const $behavior = toValue(inject(INJECTION_KET_BEHAVIOR, new Behavior(() => toValue(settings))));
  const ready = ref(false);
  const { mediaUri, settings } = args;
  let canAutoplayUnmuted = false;
  const mediaSource = computed(() => {
    const mediaUriValue = toValue(mediaUri);
    if (mediaUriValue == null) return void 0;
    return getMediaSource(mediaUriValue, toValue(settings));
  });
  canAutoplay.video({ muted: false, inline: true }).then(({ result }) => {
    canAutoplayUnmuted = result;
    ready.value = true;
  }).catch((err) => {
    console.error(err);
    ready.value = true;
  });
  const muted = computed(() => {
    if ($behavior.exists("forceUnmute")) return false;
    if ($behavior.exists("muted")) return true;
    return !canAutoplayUnmuted && $behavior.exists("autoPlay");
  });
  const autoplay = computed(() => {
    if (!canAutoplayUnmuted && $behavior.exists("muted")) return false;
    return $behavior.exists("autoPlay");
  });
  const loop = computed(() => {
    return $behavior.exists("loop");
  });
  return {
    mediaSource,
    ready,
    $behavior,
    autoplay,
    muted,
    loop
  };
}
const Timecode = defineComponent({
  name: "TimecodeDisplay",
  props: {
    time: {
      type: Number,
      required: false,
      default: 0
    },
    tag: {
      type: String,
      required: false,
      default: "span"
    }
  },
  setup(props) {
    const { time } = toRefs(props);
    const formattedTime = computed(() => {
      const _time = unref(time);
      const ms = Math.floor(_time % 1 * 1e3).toString().padStart(3, "0");
      const secs = Math.floor(_time % 60).toString().padStart(2, "0");
      const mins = Math.floor(_time / 60 % 60).toString().padStart(2, "0");
      const hrs = Math.floor(_time / 3600).toString().padStart(2, "0");
      const ret = `${hrs}:${mins}:${secs}:${ms}`;
      return ret;
    });
    return {
      formattedTime
    };
  },
  render() {
    return h(this.tag, this.formattedTime);
  }
});
export {
  INJECTION_KET_BEHAVIOR,
  Timecode,
  useExperiencePlayer
};
//# sourceMappingURL=index.js.map
